import { useEffect, useState } from 'react'

import { lazyRemoteModule } from '@space-shell/lib/runtime'

import type { IMembershipChatInjector } from '../../types'

const useMembershipChatInjector = (): [
  unknown,
  { default: () => IMembershipChatInjector } | null
] => {
  const [error, setError] = useState<unknown>(null)
  const [injector, setInjector] = useState<{ default: () => IMembershipChatInjector } | null>(null)

  useEffect(() => {
    async function importInjector() {
      try {
        const remoteModule = await lazyRemoteModule<() => IMembershipChatInjector>(
          'MembershipChat/ChatConsumerInjector'
        )

        if (!remoteModule) {
          throw new Error('Remote Module Not Defined: useMembershipChatInjector')
        }

        setInjector({ default: remoteModule })
      } catch (error) {
        setError(error)
      }
    }

    importInjector()
  }, [])

  return [error, injector]
}

export default useMembershipChatInjector
